import { memo, useMemo } from 'react';
import { useSettings } from '@wu/widget-core';
import { SectionsLayoutList } from './SectionsLayoutList';
import { SectionsLayoutMasonry } from './SectionsLayoutMasonry';
import { SectionsLayoutTabs } from './SectionsLayoutTabs';

const Layouts = {
  list: SectionsLayoutList,
  masonry: SectionsLayoutMasonry,
  tabs: SectionsLayoutTabs
};

export const SectionsLayout = memo(() => {
  const { sectionsLayout } = useSettings();

  const Layout = useMemo(() => Layouts[sectionsLayout], [sectionsLayout]);

  return <Layout />;
});
